import React, { useState, useCallback } from "react";
import {
  Card,
  Container,
  Row,
  CardBody,
  Col,
  Button,
  Form,
  Input,
  Label
} from "reactstrap";
// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import { connect } from 'react-redux';
import { addQuote } from '../../actions/quoteActions'
import SpinnerLoader from "components/Misc/Spinner";
import { useHistory } from 'react-router-dom'
import toast, { Toaster } from "react-hot-toast";
import Datetime from "react-datetime"
import {
  updateToast,
  successToast,
  errorToast
} from "shared/constants";
import moment from "moment";

function AddQuote({ addQuote }) {
    const [showSpinner, setSpinner] = useState(false);
    const [quote, setQuote] = useState('')
    const [writer, setWriter] = useState('')
    const [date, setDate] = useState(new Date())
    const [onDate, setOnDate] = useState(false)

    const history = useHistory()

    const handleQuote = (e) => {
        setQuote(e.target.value)
    }

    const handleWriter = (e) => {
        setWriter(e.target.value)
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const formattedDate = moment(date).format('MMM, DD')
        
        const newQuote = {
        quote,
        writer,
        date: onDate ? formattedDate !== 'Invalid date' ? formattedDate : null : null    
        }
        setSpinner(true)
        console.log(newQuote)
        addQuote(newQuote)
        .then(res => {
          setSpinner(false)
          toast.success("Quote added successfully", successToast);
            history.push("/admin/quotes")
        })
        .catch (err => {
          console.log("Error: ", err)
          toast.error("Something wents wrong.", errorToast)
          setSpinner(false)
        })
    }

  return (
    <>
      <SpinnerLoader showSpinner={showSpinner} />
      <SimpleHeader
        name="Add Quote"
        btn_name="Edit"
        updateList={() =>
          console.log("")
        }
      />
      <Container className="mt--4 ml-3 float-left ctgry-container">
        <Form onSubmit={(e) => onSubmit(e)}>
        <Row className="mt-2">
          <div className="col">
            <Card>
                <CardBody>
                    <Row>
                      <Col md={12}>
                        <Label className="secondary-label">Quote</Label>
                        <Input
                        type='textarea'
                        name="address"
                        placeholder="Quote"
                        className="input-secondary-style"
                        value={quote}
                        onChange={handleQuote}
                        required
                        />
                      </Col>
                      <Col md={12}>
                        <Label className="secondary-label">Writer</Label>
                        <Input
                        type='text'
                        name="address"
                        placeholder="writer"
                        className="input-secondary-style"
                        value={writer}
                        onChange={handleWriter}
                        required
                        />
                      </Col>
                      <Col md={12} className={"mt-3"}>
                        <Row>
                            <Col md={2}>
                            <div className="d-flex mt-3">
                                <label className="cstm-chkbox">
                                    <input
                                    type={'checkbox'}
                                    onChange={() => setOnDate(prev => !prev)}
                                    checked={onDate}
                                    />
                                </label>
                                <div className="ml-2"><span>On</span></div>
                            </div>
                            </Col>
                            <Col md={10}>
                                <Datetime
                                    className="cstm-dt"
                                    timeFormat={false}
                                    dateFormat={"MMM, DD"}
                                    value={date}
                                    onChange={(dt) => setDate(dt)}
                                    inputProps={{
                                        disabled: !onDate
                                    }}
                                />
                            </Col>
                        </Row>
                      </Col>
                    </Row>
                </CardBody>
            </Card>
          </div>
        </Row>
        <Row>
            <Col md={12}>
            <Button  className="default-button-background default-button-style" type="submit">
                Add
            </Button>
            </Col>
        </Row>
        </Form>
      </Container>
      <Toaster/>
    </>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    addQuote: (quote) => dispatch(addQuote(quote))
  }
}

const mapStateToProps = (state) => {
  return {
      auth: state.auth,
      error: state.error
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddQuote);